import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./signatures.css";
let opened = 0,
  previousOverflow = "";
export default function SignatureOverlay({ children, onClose, busy = false }) {
  const root = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement;
    const viewport = window.visualViewport;
    const fitViewport = () => {
      const height =
        viewport && viewport.scale === 1 ? viewport.height : window.innerHeight;
      root.current?.style.setProperty(
        "--signature-visible-height",
        `${height}px`,
      );
    };
    fitViewport();
    viewport?.addEventListener("resize", fitViewport);
    window.addEventListener("resize", fitViewport);
    if (opened++ === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    root.current?.focus();
    return () => {
      viewport?.removeEventListener("resize", fitViewport);
      window.removeEventListener("resize", fitViewport);
      if (--opened === 0) document.body.style.overflow = previousOverflow;
      if (previousFocus?.isConnected) previousFocus.focus?.();
    };
  }, []);
  return createPortal(
    <div
      ref={root}
      className="signature-overlay"
      tabIndex={-1}
      onKeyDown={(e) => {
        if (e.target.closest(".signature-overlay") !== root.current) return;
        if (e.key === "Escape" && onClose && !busy) {
          e.stopPropagation();
          onClose();
        }
        if (e.key === "Tab") {
          const items = [
            ...root.current.querySelectorAll(
              'button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),a[href],summary,[tabindex="0"]',
            ),
          ].filter((node) => node.getClientRects().length);
          if (!items.length) {
            e.preventDefault();
            return;
          }
          const first = items[0],
            last = items[items.length - 1];
          if (
            e.shiftKey &&
            (document.activeElement === first ||
              document.activeElement === root.current)
          ) {
            e.preventDefault();
            last.focus();
          } else if (
            !e.shiftKey &&
            (document.activeElement === last ||
              document.activeElement === root.current)
          ) {
            e.preventDefault();
            first.focus();
          }
        }
      }}
    >
      {children}
    </div>,
    document.body,
  );
}
